import { render } from "./UserSearchComponent.vue?vue&type=template&id=bbd3969c"
import script from "./UserSearchComponent.vue?vue&type=script&lang=js"
export * from "./UserSearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__